<template>
  <v-row
    v-if="pagination.total > 0"
    class="text-center">
    <v-col cols="3">
    </v-col>
    <v-col cols="6">
      <div style="font-size: 14px; color: gray">
        全{{ pagination.total }}件中 {{ pagination.from }} 〜 {{ pagination.to }}を表示
      </div>
      <v-pagination
        v-model="pagination.current_page"
        :length="pagination.last_page"
        :total-visible="pagination.per_page"
        @input="$emit('change', pagination)">
      </v-pagination>
    </v-col>
    <v-col
      cols="3"
      style="margin-top: 20px">
      <v-select
        v-model="pagination.per_page"
        style="width: 100px;"
        dense
        :items="['5', '10', '15', '30', '50', '100', '200']"
        label="表示件数"
        @input="$emit('change', pagination)">
      </v-select>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: 'FooterPagination',
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      pagination: {
        current_page: 0,
        last_page: 0,
        per_page: '10',
      },
    }
  },
  watch: {
    value() {
      this.pagination = this.value
    },
  },
  mounted() {

  },
}
</script>

<style scoped>

</style>
